import { ScoutLaunchAnnouncementModal } from "./ScoutLaunchAnnouncementModal";
import { ScoutLaunchTour } from "./ScoutLaunchTour";
import { useScoutLaunchAnnouncement } from "./useScoutLaunchAnnouncement";

export function ScoutLaunchAnnouncement() {
  const { phase, dismissModal, learnMore, startTour, completeTour, dismissTour, viewTourStep } =
    useScoutLaunchAnnouncement();

  return (
    <>
      <ScoutLaunchAnnouncementModal
        open={phase === "modal"}
        onDismiss={dismissModal}
        onLearnMore={learnMore}
        onStartTour={startTour}
      />
      {phase === "tour" ? (
        <ScoutLaunchTour
          onDismiss={dismissTour}
          onComplete={completeTour}
          onStepViewed={viewTourStep}
        />
      ) : null}
    </>
  );
}
